import * as React from "react";
import {connect, Dispatch} from "react-redux";
import Loading from "../components/ui/loading/Loading";
import Lead from "../model/lead/Lead";
import {RouteComponentProps} from "react-router";
import {withRouter} from "react-router-dom";
import Routes from "../navigation/route/Route";
import {OnFailure, OnSuccess, OnSuccessData} from "../store/action/actionHelpers";
import {fetchLead} from "../store/action/lead/lead";
import {notifyBugsnagAndShowToast} from "../utils/Utils";

interface RouteProps {
	/**
	 * Lead identifier.
	 */
	leadId: string
}

interface DispatchProps {
	fetchLead: (leadId: string, onSuccess: OnSuccessData<Lead>, onFailure: OnFailure) => void
}

type ComponentProps = RouteComponentProps<RouteProps>;

type Props = ComponentProps & DispatchProps

class LeadUuidRouteComponent extends React.Component<Props, {}> {

	componentDidMount() {
		this.props.fetchLead(this.props.match.params.leadId, (lead) => this.navigateToLeadDetails(lead.referenceNumber), (err) => {
			notifyBugsnagAndShowToast(err, "Fetch lead");
			this.navigateToLeadsList()
		})
	}

	render() {
		return (
			<div className={"l-page boxed"}>
				<Loading isLoading={true} />
			</div>
		)
	}

	/**
	 * Navigate to leads list
	 */
	private navigateToLeadsList() {
		this.props.history.push(Routes.LeadsList);
	}

	/**
	 * Navigate to lead details
	 */
	private navigateToLeadDetails(leadRefNo: string) {
		this.props.history.push(Routes.EditLead(leadRefNo));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLead: (leadId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			fetchLead(leadId, onSuccess, onFailure))
	}

}

export default withRouter(connect(null, mapDispatchToProps)(LeadUuidRouteComponent));